import React from "react";
import { COUNTS } from "../content";
import useInView from "../hooks/useInView";
import useCountUp from "../hooks/useCountUp";

function Count({ item, active, delay }) {
  const n = useCountUp(item.value, active, { duration: 1900, delay });

  return (
    <li className="count">
      <span className="count__n display">
        {n.toLocaleString()}
        <em>{item.suffix}</em>
      </span>
      <span className="count__label">{item.label}</span>
      <span className="count__note mono">{item.note}</span>
    </li>
  );
}

export default function Counts() {
  const [ref, inView] = useInView({ threshold: 0.3, once: true });

  return (
    <section className="counts" id="count" data-act="count" ref={ref}>
      <div className="counts__inner">
        <div className="counts__head">
          <h2 className="mono">04 — Count</h2>
          <p className="counts__lede serif">
            Small numbers, honestly reported. We would rather show these than a
            wall of borrowed logos.
          </p>
        </div>

        <ul className="counts__grid">
          {COUNTS.map((item, i) => (
            <Count key={item.label} item={item} active={inView} delay={i * 140} />
          ))}
        </ul>
      </div>
    </section>
  );
}
